import { FC, ReactNode } from 'react';
import Link from 'next/link';
import { css } from '@bts-web/utils-style-engine';
import { BuySellButton } from './subcomponents/BuySellButton';
import { IMainNavigationTranslations } from '../utils/getMainNavigationTranslations';
import { NotificationsBell } from '../../../common/components/NotificationsBell/NotificationsBell';
import { NEXT_ROUTES } from '@bts-web/utils-next-infrastructure';
import { ReadOnlyTag } from '../../../common/utils/userAccess/ReadOnlyTag';
import { ProfileDropdownMenu } from './subcomponents/ProfileDropdownMenu/ProfileDropdownMenu';
import { AppLogoWithIslamicProp } from '../Reusable/AppLogo/AppLogoWithIslamicProp.use-client';

export const appHeaderWrapperStyles = {
  display: 'flex',
  bgColor: 'neutrals.card_fill_primary',
  position: 'fixed',
  top: 0,
  insetInline: 0,
  insetInlineEnd: 0,
  zIndex: 2,
  minHeight: `72px`,
  maxHeight: '72px',
};

export const DesktopTopHeaderBar: FC<{
  pageTitleElement: ReactNode;
  hideTopBarTradeButton: boolean;
  translatedValues: IMainNavigationTranslations;
}> = ({ pageTitleElement, hideTopBarTradeButton, translatedValues }) => {
  return (
    <header
      className={`compensateMarginRightWhenScrollingIsBlocked ${css(appHeaderWrapperStyles)}`}
      data-testid="desktop header bar"
    >
      <div
        className={css({
          p: '20px',
          paddingInlineEnd: '20px',
          borderInlineEndWidth: '1px',
          borderInlineEndColor: 'neutrals.divider',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 'extra_small_3',
          maxWidth: '72px',
        })}
      >
        <Link
          aria-label="bitpanda logo"
          href={NEXT_ROUTES.PORTFOLIO}
          prefetch={false}
          className={css({
            width: '32px',
            height: '32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          })}
        >
          <AppLogoWithIslamicProp size={34} noText />
        </Link>
      </div>

      <div
        className={css({
          display: 'flex',
          alignItems: 'center',
          borderBottom: '1px solid',
          borderBottomColor: 'neutrals.divider',
          minHeight: '100%',
          flex: 1,
          py: 'extra_small_2',
          px: 'medium',
          gap: 'extra_small_2',
        })}
      >
        <div>{pageTitleElement}</div>

        <ReadOnlyTag />

        <div
          className={css({
            px: 'medium',
            display: 'flex',
            justifyContent: 'end',
            flex: 1,
          })}
        >
          {!hideTopBarTradeButton && (
            <BuySellButton>{translatedValues.buySellButtonText}</BuySellButton>
          )}
        </div>

        <div
          className={css({
            display: 'flex',
            gap: 'small',
            alignItems: 'center',
            borderInlineStartColor: 'neutrals.stroke_secondary',
            borderInlineStartWidth: '1px',
            paddingInlineStart: 'medium',
          })}
        >
          <NotificationsBell />

          <ProfileDropdownMenu translatedValues={translatedValues} />
        </div>
      </div>
    </header>
  );
};
